import { Spi, SpiFlow } from '@mx51/spi-client-js';
const DEVICE_API_KEY = 'jnHnqfW737Jg1rrVo5eZbgdZLsY1j12yjnHnqfW737Jg1rrVo5eZbgdZLsY1j12y';

class SpiService {
  _spi: Spi;
  _posId: string;
  _posName: string;
  _eftposAddress: string;
  _spiSecrets: any;
  _options: any;
  _posName: any;
  _version: any;
  _rcptFromEftpos: Boolean;
  _sigFlowFromEftpos: Boolean;
  _deviceApiKey: any;
  _serialNumber: string;
  _tenantCode: string;
  _autoResolveEftposAddress: Boolean;
  _testMode: Boolean;
  _useSecureWebSockets: Boolean;
  _log: any;
  _printMerchantCopy: Boolean;
  static _instance;

  constructor(config: any) {
    console.log('config', config)
    this._spi = null;
    this._log = console;
    this._posName = 'Krisp POS';
    this._version = '1';
    const conf = config || {};
    this._posId = conf.pos_id || 'KrispPOS';
    this._eftposAddress = conf.eftpos_address;
    this._serialNumber = conf.serial_number;
    this._testMode = conf.test_mode;
    this._tenantCode = conf.tenant_code === 'other'? conf.other_tenant_code : conf.tenant_code || 'wbc';
    this._deviceApiKey = conf.device_api_key || 'jnHnqfW737Jg1rrVo5eZbgdZLsY1j12yjnHnqfW737Jg1rrVo5eZbgdZLsY1j12y';
    this._spiSecrets = conf.spi_secrets;
    this._autoResolveEftposAddress = conf.auto_address;
    this._useSecureWebSockets = conf.use_secure_web_sockets;
  }

  static getInstance(config) {
    if (!this._instance) {
      this._instance = new SpiService(config);
    }
    return this._instance;
  }

  start() {
    this._log.info('Starting SPI service');
    try {
      this._spi = new Spi(this._posId, this._serialNumber, this._eftposAddress, this._spiSecrets);
      this._spi.SetPosInfo(this._posName, this._version);
      this._spi.SetSecureWebSockets(true);
      this.setAutoAddressResolutionState();
    } catch(e) {
      this._log.error(e.stack);
    }

    this._spi.PrintingResponse = this.onSpiResponse.bind(this);
    this._spi.TerminalStatusResponse = this.onSpiResponse.bind(this);
    this._spi.BatteryLevelChanged = this.onSpiResponse.bind(this);
    this._spi.Start();
    this.printStatusAndActions();
  }

  async getTenantsList() {
    const tenants = await Spi.GetAvailableTenants(this._posName, this._deviceApiKey, 'AU');
    const defaultTenantList = [
      {
        code: 'wbc',
        name: 'Westpac'
      },
      {
        code: 'till',
        name: 'Till Payments',
      },
    ];
    return tenants.Data.length ? tenants.Data : defaultTenantList;
  }

  onSpiResponse() {
    this._spi.AckFlowEndedAndBackToIdle();
    this.printStatusAndActions();
  }

  setAutoAddressResolutionState() {
    this._spi.SetTenantCode(this._tenantCode);
    this._spi.SetDeviceApiKey(this._deviceApiKey || DEVICE_API_KEY);
    this._spi.SetTestMode(this._testMode);
    this._spi.SetSecureWebSockets(this._useSecureWebSockets);
    this._spi.SetAutoAddressResolution(this._autoResolveEftposAddress);
  }

  printStatusAndActions() {
    this.printFlowInfo();
  }

  printFlowInfo() {
    switch (this._spi.CurrentFlow) {
      case SpiFlow.Pairing:
        this._log.info(this._spi.CurrentPairingFlowState);
        break;
      case SpiFlow.Transaction:
        this._log.info(this._spi.CurrentTxFlowState);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Unable to handle flow state', this._spi.CurrentFlow);
        console.log('Current status', this._spi.CurrentStatus);
    }
  }

}

export { SpiService };